import React from 'react';
import { Container } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone, faLocationPin } from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import data from '../data/stdominicana-original';

const Footer = () => {

    return (
        <Container fluid style={{backgroundColor: '#f8f9fa', textAlign: 'center', padding: '10px'}}>
            <footer className="text-center text-lg-start bg-body-tertiary text-muted">

                <section className="">
                    <div className="container text-center text-md-start mt-5">
                        <div className="row mt-3">
                            <div className="col-md-4 mx-auto mb-4">
                                <img
                                    src={data.logo}
                                    className="align-top brand-logo"
                                    alt={data.title}
                                />
                            </div>

                            <div className="col-md-8 mx-auto mb-md-0 mb-4">
                                <h6 className="text-uppercase fw-bold mb-4">Contactenos</h6>
                                <p>
                                    <FontAwesomeIcon icon={faLocationPin} className="me-3" />
                                        {data.contact.address}
                                </p>
                                <p>
                                    <FontAwesomeIcon icon={faEnvelope} className="me-3" />
                                    {data.contact.email}
                                </p>
                                <p><FontAwesomeIcon icon={faWhatsapp} className="me-3" /> {data.contact.whatsapp}</p>
                                <p><FontAwesomeIcon icon={faWhatsapp} className="me-3" /> {data.contact.whatsapp2}</p>
                                <p><FontAwesomeIcon icon={faPhone} className="me-3" /> {data.contact.phone}</p>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="text-center p-4">
                    Powered by:
                    <a className="text-reset fw-bold" href="https://www.coralanm.com/"> Coralan Multiservice</a>
                </div>
            </footer>
        </Container>
    );
};

export default Footer;
